module.exports = __webpack_public_path__ + "img/logo.94192751.png";